<script>
  import {orgEyeOn} from "@nrk/origo";
</script>

<span data-org-tooltip="Publikumsmetadata" class="eye">
  {@html orgEyeOn}
</span>

<style>
  .eye {
    margin-left: var(--org-small);
    font-size: 0.8rem;
  }
</style>